import _ from 'lodash';

export function countViews(views = 0, demoViews = 0) {
  return _.sum([views, demoViews, 0]);
}
